import React from "react";
import {  NavLink, useLocation } from "react-router-dom";
// import Logo from '../media/logo.jpg';
import SVGComponent from "./svgviewer-react-output";
import "./navbar.scss";

const NavBar = () => {
  const location = useLocation();
  const isSubServiceActive =
    location.pathname.includes("/serwis-motocykli") ||
    location.pathname.includes("/serwis-quadow") ||
    location.pathname.includes("/serwis-skuterow") ||
    location.pathname.includes("/przeglady-techniczne") ||
    location.pathname.includes("/cennik");
  const isSubOtherActive =
    location.pathname.includes("/transport-motocykli") ||
    location.pathname.includes("/doradztwo") ||
    location.pathname.includes("/zimowanie") ||
    location.pathname.includes("/skup");

  return (
    <header className="home-header">
      <nav className="home-header_navigate">
        <NavLink to="/" className="home-header_navigate-logo">
          <div className="logo_descr">
            <SVGComponent/>
          </div>
        </NavLink>

        <ul>
          <li>
            <NavLink to="/" end>
              Strona główna
            </NavLink>
          </li>
          <li className={isSubServiceActive ? "active-parent" : "" }>
            <NavLink to="/serwis">Serwis</NavLink>
            <ul>
              <li>
                <NavLink to="/serwis-motocykli">Serwis motocykli</NavLink>
              </li>
              <li>
                <NavLink to="/serwis-quadow">Serwis quadów</NavLink>
              </li>
              <li>
                <NavLink to="/serwis-skuterow">Serwis skuterów</NavLink>
              </li>
              <li>
                <NavLink to="/przeglady-techniczne">Przeglądy techniczne</NavLink>
              </li>
              <li>
                <NavLink to="/cennik">Cennik</NavLink>
              </li>
            </ul>
          </li>
          <li className={isSubOtherActive ? "active-parent" : "" }>
            <NavLink to="/pozostale_uslugi">Pozostałe usługi</NavLink> 
            <ul>
              <li>
                <NavLink to="/transport-motocykli">Transport motocykli</NavLink>
              </li>
              <li>
                <NavLink to="/doradztwo">Doradztwo podczas zakupu</NavLink>
              </li>
              <li>
                <NavLink to="/zimowanie">Zimowanie motocykli</NavLink>
              </li>
              <li>
                <NavLink to="/skup">Skup motocykli</NavLink>
              </li>
            </ul>
          </li>
          <li>
            <NavLink to="/motocykle">Motocykle</NavLink>
          </li>
          <li>
            <NavLink to="/o-firmie">O firmie</NavLink>
          </li>
          <li>
            <NavLink to="/kontakt">Kontakt</NavLink>
          </li>
          <li>
            <a
              href="https://allegro.pl/uzytkownik/promotoserwis"
              target="_blank"
              rel="noopener noreferrer"
              className="allegro-btn"
            >
              Sklep Allegro
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default NavBar;

